<template>
  <div v-if="!route.meta || !route.meta.hidden">
    <template v-if="!alwaysShow && hasOneVisibleChild(route.children, route)">
      <el-menu-item :index="resolvePath(onlyChild.path)">
        <i :class="onlyChild.meta && onlyChild.meta.icon" />
        <span slot="title">{{ onlyChild.meta && onlyChild.meta.title }}</span>
      </el-menu-item>
    </template>
    <el-submenu v-else :index="routeBasePath">
      <template slot="title">
        <i :class="route.meta && route.meta.icon" />
        <span>{{ route.meta && route.meta.title }}</span>
      </template>
      <sidebar-item v-for="child in visibleChildren" :key="child.path" :route="child" :base-path="routeBasePath" />
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    route: { type: Object, required: true },
    basePath: { type: String, default: '' }
  },
  data() {
    return { onlyChild: null }
  },
  computed: {
    alwaysShow() {
      return Boolean(this.route.meta && this.route.meta.alwaysShow)
    },
    visibleChildren() {
      return (this.route.children || []).filter(item => !item.meta || !item.meta.hidden)
    },
    routeBasePath() {
      return this.joinPath(this.basePath, this.route.path)
    }
  },
  methods: {
    hasOneVisibleChild(children = [], parent) {
      const visible = children.filter(item => !item.meta || !item.meta.hidden)
      if (visible.length === 1) {
        this.onlyChild = visible[0]
        return true
      }
      if (!visible.length) {
        this.onlyChild = { ...parent, path: '' }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (/^https?:/.test(routePath)) return routePath
      if (routePath && routePath.startsWith('/')) return routePath
      return this.joinPath(this.routeBasePath, routePath)
    },
    joinPath(basePath, routePath) {
      if (routePath && routePath.startsWith('/')) return routePath
      const paths = [basePath, routePath].filter(Boolean).map(path => path.replace(/^\/+|\/+$/g, ''))
      return `/${paths.join('/')}`
    }
  }
}
</script>
